import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const getAllNeedReviews = createAsyncThunk('reviews/need/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`cleaning-review/get-all-property-schedule-Pending-cleaning-review`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})
export const getAllReviewed = createAsyncThunk('reviews/reviewed/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`cleaning-review/get-all-property-schedule-cleaning-reviewed`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addReviews = createAsyncThunk('reviews/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`cleaning-review/create-cleaning-review`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allNeedReviews: [],
  allReviewed: [],
  error: null
}

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    resetAuthState: () => {
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllNeedReviews.pending, (state) => {
        state.isLoading = true
        state.allNeedReviews = []
      })
      .addCase(getAllNeedReviews.fulfilled, (state, action) => {
        state.isLoading = false
        state.allNeedReviews = action.payload?.data?.data
      })
      .addCase(getAllNeedReviews.rejected, (state, action) => {
        state.isLoading = false
        state.allNeedReviews = []
        state.error = action.error.message
      })
      .addCase(getAllReviewed.pending, (state) => {
        state.isLoading = true
        state.allReviewed = []
      })
      .addCase(getAllReviewed.fulfilled, (state, action) => {
        state.isLoading = false
        state.allReviewed = action.payload?.data?.data
      })
      .addCase(getAllReviewed.rejected, (state, action) => {
        state.isLoading = false
        state.allReviewed = []
        state.error = action.error.message
      })
      .addCase(addReviews.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addReviews.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addReviews.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = reviewsSlice.actions
export default reviewsSlice.reducer
